/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1408
 */

"use strict"

var /* [auto-meaningful-name] */require_311_$_311$ObjectSetPrototypeOf = require(/* 311 */"./311").ObjectSetPrototypeOf
module.exports = o
var i = require(/* 1409 */"./1409")
function o(e) {
  if (!(this instanceof o)) {
    return new o(e)
  }
  i.call(this, e)
}
require_311_$_311$ObjectSetPrototypeOf(o.prototype, i.prototype)
require_311_$_311$ObjectSetPrototypeOf(o, i)
o.prototype._transform = function (e, t, n) {
  n(null, e)
}
